"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = require("./attributes/base");
exports.Attribute = base_1.default;
var color_1 = require("./attributes/color");
exports.Color = color_1.default;
var opacity_1 = require("./attributes/opacity");
exports.Opacity = opacity_1.default;
var position_1 = require("./attributes/position");
exports.Position = position_1.default;
var shape_1 = require("./attributes/shape");
exports.Shape = shape_1.default;
var size_1 = require("./attributes/size");
exports.Size = size_1.default;
var factory_1 = require("./factory");
exports.getAttribute = factory_1.getAttribute;
exports.registerAttribute = factory_1.registerAttribute;
factory_1.registerAttribute('Color', color_1.default);
factory_1.registerAttribute('Opacity', opacity_1.default);
factory_1.registerAttribute('Position', position_1.default);
factory_1.registerAttribute('Shape', shape_1.default);
factory_1.registerAttribute('Size', size_1.default);
tslib_1.__exportStar(require("./interface"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/attr/lib/index.js
// module id = 579
// module chunks = 37